<div class="role-ba__header">
  @if (!exportMode) {
  <div class="role-ba__edit-button-div">
    @if (editMode) {
      <button
        mat-raised-button
        class="role-ba__edit-btn role-ba__edit-btn--text"
        (click)="onCancelEdit()"
      >
        {{ 'general.cancel' | translate }}
      </button>

      <button
        mat-icon-button
        class="role-ba__edit-btn role-ba__edit-btn--icon"
        (click)="onCancelEdit()"
        [attr.aria-label]="'general.cancel' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <button
      mat-flat-button
      class="role-ba__edit-btn role-ba__edit-btn--text"
      [disabled]="editMode && (!hasChanges() || isSaving)"
      (click)="onToggleEdit()"
    >
      {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
    </button>

    <button
      mat-icon-button
      class="role-ba__edit-btn role-ba__edit-btn--icon"
      [disabled]="editMode && (!hasChanges() || isSaving)"
      (click)="onToggleEdit()"
      [attr.aria-label]="(editMode ? ('general.save' | translate) : ('general.edit' | translate))"
    >
      <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
    </button>
  </div>
  }

  @if (editMode) {
    <mat-form-field appearance="outline" class="role-ba__search-field">
      <mat-label>{{ 'baCatalog.roleBa.searchLabel' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'baCatalog.roleBa.searchPlaceholder' | translate"
        [(ngModel)]="searchTerm"
        (input)="filterCatalogues()"
      />
      @if (searchTerm) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }
</div>

@if (editMode) {
  <div class="role-ba__catalog-list">
    @for (catalog of filtersCatalogues; track catalog.id) {
      <label class="role-ba__catalog-item">
        <mat-checkbox
          type="checkbox"
          [checked]="isKatalogSelected(catalog)"
          (change)="onKatalogToggle(catalog.id, $event.checked)"
        ></mat-checkbox>

        <div class="role-ba__text">
          <div class="role-ba__title-row">
            <span
              class="role-ba__badge"
              [ngClass]="isAllegro(catalog)
                ? 'role-ba__badge--allegro'
                : 'role-ba__badge--rvse'"
            >
              @if (isAllegro(catalog)) {
                ALLEGRO
              } @else {
                RVSE{{ catalog.rvseVersion }}
              }
            </span>
            <span class="role-ba__title-line">
              {{ 'baCatalog.roleBa.pg' | translate }} {{ catalog.preisgruppe }}
              – {{ catalog.bezeichnung }}
            </span>
          </div>
        </div>
      </label>
    }
  </div>
  <!-- NP20-822: Im Bearbeiten stehen alle Kataloge zur Auswahl; Abbrechen und Speichern kleben
       am unteren Rand und rasten am Ende der Liste ein. -->
  @if (!exportMode) {
    <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
      <button mat-stroked-button type="button" (click)="onCancelEdit()">
        {{ 'general.cancel' | translate }}
      </button>
      <button mat-flat-button type="button" [disabled]="!hasChanges() || isSaving" (click)="onToggleEdit()">
        {{ 'general.save' | translate }}
      </button>
    </div>
  }
} @else {
  <div class="role-ba__catalog-wrapper">
    @if (assignedCatalogs.length === 0) {
      <div class="role-ba__catalog-container">
        <mat-card appearance="outlined" class="role-ba__no-skills">
          <mat-card-content>
            {{ 'baCatalog.roleBa.noRoleSelected' | translate }}
          </mat-card-content>
        </mat-card>
      </div>
    } @else {
      @for (catalog of assignedCatalogs; track catalog.id) {
        <div class="role-ba__catalog-item role-ba__catalog-item--readonly">
          @if (exportMode && !twoPagerMode) {
            <mat-checkbox
              [checked]="selectedExportIds.includes(catalog.id)"
              (change)="toggleExportSelection(catalog.id, $event.checked)"
            ></mat-checkbox>
          }
          <div class="role-ba__text">
            <div class="role-ba__title-row">
              <span
                class="role-ba__badge"
                [ngClass]="isAllegro(catalog)
                  ? 'role-ba__badge--allegro'
                  : 'role-ba__badge--rvse'"
              >
                @if (isAllegro(catalog)) {
                  ALLEGRO
                } @else {
                  RVSE{{ catalog.rvseVersion }}
                }
              </span>
              <span class="role-ba__title-line">
                {{ 'baCatalog.roleBa.pg' | translate }} {{ catalog.preisgruppe }}
                – {{ catalog.bezeichnung }}
              </span>
            </div>
          </div>
        </div>
      }
    }
  </div>
}
